import { useTranslation } from 'react-i18next';
import { useDashboardStore } from '../../stores/Layout/dashboard';
import repeat from '../../assets/icons/repeat.svg';

const Relaunch = () => {
    const { t } = useTranslation();
    const { relaunchsInfo } = useDashboardStore();

  return (
    <div className="w-full sm:h-full flex flex-col justify-start items-start p-3 ">
    {/* Requetes expirées */}
    <div className="flex items-center gap-4">
      <div className="p-3 bg-yellow-trio rounded-xl">
        <img src={repeat} alt="repeat" className="w-6 h-6 text-grey-trio" />
      </div>
      <div>
        <h1 className="text-xl font-bold text-gray-700 font-K2D">
          {t("dashboard.relaunchTitle")}
        </h1>
        <p className="text-sm sm:text-md text-gray-600 mt-1">
          {t("dashboard.relaunchSubtitle")}
        </p>
      </div>
    </div>
    <div className="w-full h-full flex flex-col justify-start items-center bg-white mb-4 p-2 sm:p-4 gap-3 sm:gap-4 overflow-y-auto">
      {relaunchsInfo?.length > 0 ? relaunchsInfo?.map((item: any) => (
        <div 
          key={item?.id} 
          className="w-full h-auto flex flex-col justify-start items-start border border-gray-100 rounded-xl bg-white shadow-xl p-2 sm:p-3" 
          >
          <div className="text-blue-500 w-36 border border-blue-500 rounded-full text-sm px-2 py-1 text-center mb-2">{item?.createdAt}</div>
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center w-full gap-2">
            <h1 className="text-base sm:text-lg lg:text-xl font-bold text-gray-700 font-K2D ml-1">
              {item?.namePartner}
            </h1>
            <p className="text-xs sm:text-sm text-gray-600 italic ml-1">{t("dashboard.requestsCount")} : <span className="font-bold">{item?.docRequestCount}</span></p>
          </div>
          <p className="text-xs sm:text-sm text-gray-600 italic ml-1">{t("dashboard.relaunchForMission")}: <span className="font-bold">{item?.nameMission}</span></p>
          <p className="text-xs sm:text-sm text-gray-600 italic ml-1"><span className="font-bold">{item?.namePartner}</span></p>
        </div>
      )) : 
        <div className="text-center 2xl:py-12">
          <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full hidden 2xl:flex items-center justify-center">
            <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">{t("dashboard.noRelaunchTitle")}</h3>
          <p className="text-gray-500">{t("dashboard.noRelaunchText")}</p>
        </div>
      }
    </div>
  </div>
  )
}

export default Relaunch